"use strict";
var Observable_1 = require('../../Observable');
var startWith_1 = require('../../operator/startWith');
Observable_1.Observable.prototype.startWith = startWith_1.startWith;
//# sourceMappingURL=startWith.js.map


//////////////////
// WEBPACK FOOTER
// C:/firebase/gbord/~/rxjs/add/operator/startWith.js
// module id = ../../../../rxjs/add/operator/startWith.js
// module chunks = 3